import { render, staticRenderFns } from "./PrintMessage.vue?vue&type=template&id=39884e97&scoped=true"
import script from "./PrintMessage.vue?vue&type=script&lang=js"
export * from "./PrintMessage.vue?vue&type=script&lang=js"
import style0 from "./PrintMessage.vue?vue&type=style&index=0&id=39884e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39884e97",
  null
  
)

export default component.exports